// extracted by mini-css-extract-plugin
export default {"root_empty":"DXZNNNv1zD","root":"ACvunxu_Mo"};